import { ChangeDetectionStrategy, Component, input, OnInit, signal } from '@angular/core';
import { quoteStyle } from '@shared/components/quote/config';
import { QuoteTheme } from '@shared/components/quote/enum';
import { Quote } from '@shared/components/quote/model';
import { QuoteStyle } from '@shared/components/quote/model/quote-style';
import { ColorClassPipe, TruncatePipe } from '@shared/pipes';

@Component({
  selector: 'app-quote',
  styleUrl: './quote.component.scss',
  templateUrl: './quote.component.html',
  imports: [ColorClassPipe, TruncatePipe],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class QuoteComponent implements OnInit {
  readonly quote = input.required<Quote>();
  readonly maxLength = input(0);
  readonly theme = input<keyof typeof QuoteTheme>('WHITE');
  quoteStyle = signal<QuoteStyle>(null!);

  ngOnInit(): void {
    this.quoteStyle.set({ ...quoteStyle[QuoteTheme[this.theme()]] });
  }
}
